/**
 * Validates push notification template form (all locales).
 * Returns errors by locale key: { [localeKey]: { title?: string, messageBody?: string } }
 */
const TITLE_MAX_LENGTH = 50;
const MESSAGE_MAX_LENGTH = 255;

const validate = (byLocale, localeSections) => {
  const errors = {};
  if (!localeSections || !Array.isArray(localeSections)) return errors;

  localeSections.forEach(({ key }) => {
    const data = byLocale[key] || {};
    const title = (data.title != null ? String(data.title) : '').trim();
    const messageBody = (data.messageBody != null ? String(data.messageBody) : '').trim();
    const sectionErrors = {};

    if (!title) {
      sectionErrors.title = 'required';
    } else if (title.length > TITLE_MAX_LENGTH) {
      sectionErrors.title = 'pushNotificationTemplateValidationTitleMaxLength';
    }

    if (!messageBody) {
      sectionErrors.messageBody = 'required';
    } else if (messageBody.length > MESSAGE_MAX_LENGTH) {
      sectionErrors.messageBody = 'pushNotificationTemplateValidationMessageMaxLength';
    }

    if (Object.keys(sectionErrors).length > 0) {
      errors[key] = sectionErrors;
    }
  });

  return errors;
};

export default validate;
export { TITLE_MAX_LENGTH, MESSAGE_MAX_LENGTH };
